import React from 'react'
import BannerTop from '../../../assets/images/BannerContainer.png'
import ProfileTop from '../../../assets/images/profilejob.png'
import styles from './style.module.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPencil } from '@fortawesome/free-solid-svg-icons'
import constant from '../../../constant'
import parse from "html-react-parser";
import nl2br from 'react-nl2br'


const Preview = ({ data }) => {
    console.log(data.ABOUT_COMPANY)
    return (
        <div>
            <div className='container-fluid'>
                <div className='row mb-3'>
                    <div className='col-md-12'>
                        <div className={`${styles['profile-card']}`}>
                            <div className={`${styles['profile-header']}`}>
                                <img
                                    src={
                                        data.COMPANY_HEADER_BACKGROUND
                                            ? `${process.env.REACT_APP_BASE_URL}/company/header-background/${data.COMPANY_HEADER_BACKGROUND}`
                                            : BannerTop
                                    }
                                    alt={data.COMPANY_NAME} className={`${styles['profile-banner']}`} />
                            </div>
                            <div className={`${styles['profile-content']} d-flex justify-content-between`}>
                                <div className={`${styles['logo-profile']}`}>
                                    <div className={`${styles['profile-logo']}`}>
                                        <img src={`${process.env.REACT_APP_BASE_URL}/company/logo/${data.COMPANY_LOGO}`} alt="RK Logo" />
                                    </div>
                                    <h2 className={`${styles['profile-title']} ms-2 mb-4`}>{data.COMPANY_NAME}</h2>
                                </div>
                                {/* <div className='mt-3'>
                                    <a className={`${styles['edit-btn']}`} href='#'><FontAwesomeIcon icon={faPencil} /></a>
                                </div> */}
                            </div>
                        </div>
                    </div>
                </div>
                <div className='row'>
                    <div className='col-md-12'>
                        <div className={`${styles['profile-details']} ${styles['mbb-50']}`}>

                            <div className='d-flex align-items-center mb-3 justify-content-between'>

                                <h4 className={`${styles['title-main']}`}>Company Details</h4>
                                <a href={constant.component.EditProfile.url} className={`${styles['edits-btn']} btn`}><FontAwesomeIcon className='pe-2' icon={faPencil} />Edit Profile</a>
                            </div>
                            <hr />

                            <div className="row">
                                <div className='col-md-12'>
                                    <ul className={`${styles['com-details']} list-unstyled`}>
                                        <li className="d-flex justify-content-start">
                                            <span className="fw-bold w-25">Company Size:</span>
                                            <span className="text-secondary">{data.COMPANY_SIZE}</span>
                                        </li>
                                        <li className="d-flex justify-content-start mt-2">
                                            <span className="fw-bold w-25">Founded:</span>
                                            <span className="text-secondary">{data.FOUNDED}</span>
                                        </li>
                                        <li className="d-flex justify-content-start mt-2">
                                            <span className="fw-bold w-25">Headquarter:</span>
                                            <span className="text-secondary">  {data.HEADQUARTERS}</span>
                                        </li>
                                        <li className="d-flex justify-content-start mt-2">
                                            <span className="fw-bold w-25">Website:</span>
                                            <span className="text-secondary"> {data.WEBSITE}</span>
                                        </li>
                                        <li className="d-flex justify-content-start mt-2">
                                            <span className="fw-bold w-25">FAX Number:</span>
                                            <span className="text-secondary"> {data.FAX_NUMBER ? data.FAX_NUMBER : "NA"}</span>
                                        </li>
                                        <li className="d-flex justify-content-start mt-2">
                                            <span className="fw-bold w-25">Company Category:</span>
                                            <span className="text-secondary"> {data.EMPLOYER_CATEGORY}</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div className='d-flex align-items-center mt-3 justify-content-between'>
                                <h4 className={`${styles['title-main']}`}>About Us</h4>
                            </div>
                            <hr />
                            <div className="row">
                                <div className={`${styles['font-fam']} col-md-12`}>
                                        {data?.ABOUT_COMPANY ? nl2br(parse(data?.ABOUT_COMPANY)) : ""}
                                </div>
                            </div>
                            <div className='d-flex align-items-center my-3 justify-content-between'>
                                <h4 className={`${styles['title-main']}`}>Contact Information</h4>
                            </div>
                            <hr />

                            <div className="row">
                                <div className='col-md-12'>
                                    <ul className={`${styles['com-details']} list-unstyled`}>
                                        <li className="d-flex justify-content-start">
                                            <span className="fw-bold w-25">Primary Email:</span>
                                            <span className="text-secondary"> {data.EMAIL}</span>
                                        </li>
                                        <li className="d-flex justify-content-start mt-2">
                                            <span className="fw-bold w-25">Secondary Email:</span>
                                            <span className="text-secondary"> {data.SECONDARY_EMAIL
                                                ? data.SECONDARY_EMAIL
                                                : "NA"}</span>
                                        </li>
                                        <li className="d-flex justify-content-start mt-2">
                                            <span className="fw-bold w-25">Contact No.:</span>
                                            <span className="text-secondary"> {data.PHONE_CODE} {data.MOBILE}</span>
                                        </li>

                                        <li className="d-flex justify-content-start mt-2">
                                            <span className="fw-bold w-25">Location:</span>
                                            <span className="text-secondary"> {data.LOCATION ? data.LOCATION : "NA"} </span>
                                        </li>
                                        <li className="d-flex justify-content-start mt-2">
                                            <span className="fw-bold w-25">Pin Code:</span>
                                            <span className="text-secondary"> {data.PINCODE}</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>

                            <div className='d-flex align-items-center my-3 justify-content-between'>

                                <h4 className={`${styles['title-main']}`}>Contact Person Details</h4>
                            </div>
                            <hr />

                            <div className="row">
                                <div className='col-md-12'>
                                    <ul className={`${styles['com-details']} list-unstyled`}>
                                        <li className="d-flex justify-content-start">
                                            <span className="fw-bold w-25">Contact Person Designtion:</span>
                                            <span className="text-secondary"> {data.CONTACT_PERSON_DESIGNATION}</span>
                                        </li>
                                        <li className="d-flex justify-content-start mt-2">
                                            <span className="fw-bold w-25">Contact Person:</span>
                                            <span className="text-secondary"> {data.CONTACT_PERSON}
                                            </span>
                                        </li>
                                        <li className="d-flex justify-content-start mt-2">
                                            <span className="fw-bold w-25">Phone 1:</span>
                                            <span className="text-secondary">  {data.PHONE_1 ? data.PHONE_1 : "NA"}
                                            </span>
                                        </li>
                                        <li className="d-flex justify-content-start mt-2">
                                            <span className="fw-bold w-25">Phone 2:</span>
                                            <span className="text-secondary"> {data.PHONE_2 ? data.PHONE_2 : "NA"}
                                            </span>
                                        </li>
                                    </ul>
                                </div>
                            </div>

                            <div className='d-flex align-items-center my-3 justify-content-between'>

                                <h4 className={`${styles['title-main']}`}>Social Profile Details</h4>
                            </div>
                            <hr />

                            <div className="row">
                                <div className='col-md-12'>
                                    <ul className={`${styles['com-details']} list-unstyled`}>
                                        <li className="d-flex justify-content-start">
                                            <span className="fw-bold w-25">Facebook Page URL:</span>
                                            <span className="text-secondary">   {data.FB_URL}</span>
                                        </li>
                                        <li className="d-flex justify-content-start mt-2">
                                            <span className="fw-bold w-25">Linkedin Profile URL:</span>
                                            <span className="text-secondary"> {data.CONTACT_PERSON}
                                            </span>
                                        </li>
                                        <li className="d-flex justify-content-start mt-2">
                                            <span className="fw-bold w-25">Twitter URL:</span>
                                            <span className="text-secondary">  {data.TWITTER_URL}
                                            </span>
                                        </li>
                                    </ul>
                                </div>
                            </div>

                            <div className='d-flex align-items-center my-3 justify-content-between'>

                                <h4 className={`${styles['title-main']}`}>Social Profile Details</h4>
                            </div>
                            <hr />

                            <div className="row">
                                <div className='col-md-12'>
                                    <ul className={`${styles['com-details']} list-unstyled`}>
                                        <li className="d-flex justify-content-start">
                                            <span className="fw-bold w-25">Facebook Page URL:</span>
                                            <span className="text-secondary">   {data.FB_URL}</span>
                                        </li>
                                        <li className="d-flex justify-content-start mt-2">
                                            <span className="fw-bold w-25">Linkedin Profile URL:</span>
                                            <span className="text-secondary"> {data.CONTACT_PERSON}
                                            </span>
                                        </li>
                                        <li className="d-flex justify-content-start mt-2">
                                            <span className="fw-bold w-25">Twitter URL:</span>
                                            <span className="text-secondary">  {data.TWITTER_URL}
                                            </span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Preview